import { Container, Grid, Box, Link } from '@mui/material';
import React from 'react';
import OurCover from '../../Component/OurCover/OurCover.js';
import Clients from '../../Component/Clients/Clients.js';
import OurTeam from '../../Component/Ourteam/OurTeam.js';

import StunningScss from './Stunning.module.scss';
import office1 from '../../Common/Image/office1.jpg';
import office2 from '../../Common/Image/office2.jpg';

import { StunCompData } from '../../Data/stunCompData';

import SkillsScss from './Skills.module.scss';
import skills1 from '../../Common/Image/skills.jpg';
import { SkillsData } from '../../Data/skillsData';

import FactsScss from './Facts.module.scss';
import StunComp from '../../Component/StunComp/StunComp.js';

function About() {
    return (
        <div>
            <OurCover ourHead="About Us" title="We help startups and digital agencies launc projects on time" />
            {/* Stuning */}
            <section id={StunningScss.stunning}>
                <Container maxWidth='lg'>
                    <Box className={StunningScss.stunningHead}>
                        <strong>make it stunning</strong>
                        <h2>Something about us</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                    </Box>
                    <Grid container className={StunningScss.stunningBody}>
                        <Grid item md={6} sm={6} xs={12} sx={{ px: "1rem" }}>
                            <Box className={StunningScss.stunningBodyImage}>
                                <img src={office1} alt='' />
                            </Box>
                        </Grid>
                        <Grid item md={6} sm={6} xs={12} sx={{ px: "1rem" }}>
                            <Box className={StunningScss.stunningBodyImage}>
                                <img src={office2} alt='' />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container className={StunningScss.stunningFoot}>
                        {
                            StunCompData.map(stundata =>
                                stundata.id < 4 ?
                                    <Grid item xs={12} sm={6} md={4} key={stundata.id} sx={{ px: '15px' }}>
                                        <StunComp img={stundata.img} head={stundata.head} content={stundata.content} />
                                    </Grid>
                                    : ''
                            )
                        }

                    </Grid>
                </Container>
            </section >
            {/* Skills */}
            <section id={SkillsScss.skills}>
                <Grid container>
                    <Grid item md={6} sm={6} xs={12}>
                        <Box className={SkillsScss.skillsLeft}>
                            <img src={skills1} alt=""></img>
                        </Box>
                    </Grid>
                    <Grid item md={6} sm={6} xs={12}>
                        <Box className={SkillsScss.skillsRight}>
                            <span>our skills</span>
                            <p>Make it stand out.</p>
                            <Box className={SkillsScss.skillsBox}>

                                {SkillsData ?
                                    SkillsData.map(skillItem =>
                                        <Box className={SkillsScss.skillsItem} key={skillItem.id}>
                                            <Box className={SkillsScss.skillsItemHead}>
                                                <span className={SkillsScss.skillsItemName}>{skillItem.skillsName}</span>
                                                <span className={SkillsScss.skillsItemCount}> {skillItem.skillsCount}</span>
                                            </Box>
                                            <Box className={SkillsScss.skillsBody}>
                                                <Box className={SkillsScss.skillsItemAbsolute} sx={{ width: skillItem.skillsCount }}></Box>
                                            </Box>
                                        </Box>

                                    ) :
                                    <Box>
                                        Null
                                    </Box>
                                }
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </section >
            {/* Facts */}
            <section id={FactsScss.facts}>
                <Container maxLength='lg'>
                    <Grid container>
                        <Grid item xs={12} sm={6} md={6}>
                            <Box className={FactsScss.factsLeft}>
                                <span>fun facts</span>
                                <p>A focused team with a <br /> specialized skill set</p>
                                <Link href='#' className={FactsScss.factButton}>learn more</Link>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <Box className={FactsScss.factsRight}>
                                <Box className={FactsScss.factsItem}>
                                    <Box className={FactsScss.factsItemLeft}>
                                        210
                                    </Box>
                                    <Box className={FactsScss.factsItemRight}>
                                        <span>Success projects</span>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been .</p>
                                    </Box>
                                </Box>
                                <Box className={FactsScss.factsItem}>
                                    <Box className={FactsScss.factsItemLeft}>
                                        270
                                    </Box>
                                    <Box className={FactsScss.factsItemRight}>
                                        <span>Features added</span>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been .</p>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            <OurTeam />
            <Clients />
        </div>
    )
}

export default About;
